import { ulid } from 'ulid';
import { createGreenPattern } from './js/html/utils/createGreenPattern';
import { loadCSS, loadJS, loadJSON } from './js/http';
import { randomId } from './js/utils/randomId';
if (typeof globalThis === 'undefined')
    window.globalThis = window;
export function splash(files, htmlRoot = document.body, socialId) {
    var _a;
    const startDate = new Date();
    const trace_id = ulid();
    const scope = (_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.getCurrentScope();
    scope === null || scope === void 0 ? void 0 : scope.setTag('trace_id', trace_id);
    const bg = createGreenPattern();
    bg.style.backgroundColor = '#759951';
    htmlRoot.appendChild(bg);
    if (navigator.userAgent.indexOf('Opera Mini') >= 0 && !window.requestAnimationFrame) {
        throw new Error(`[ciliz.splash]: unsupported_browser`);
    }
    Progress.injectCSS();
    const p = new Progress();
    bg.appendChild(p.el);
    const prepareUrl = (url) => {
        if (url.indexOf('splash') >= 0)
            throw new Error('splash in preloading urls');
        if (socialId === 'fb') {
            return `//cdn.ciliz.com/html/${url}`;
        }
        return url;
    };
    const serverUrl = `https://butilochka.cdnvideo.ru/mobile/server.json?${randomId()}`;
    const tasks = [].concat([
        loadJSON(serverUrl, p.num('server'))
            .then((serverJSON) => loadJSON(serverJSON.assets.url, p.num('assets'))
            .then((assetsJSON) => ({
            assets: assetsJSON,
            server: serverJSON
        })))
            .catch(() => undefined)
    ], files.css.map(prepareUrl).map((css) => {
        if (css.indexOf('preloader') >= 0)
            return loadCSS(css).then(p.bool('css'));
        return loadCSS(css);
    }), files.js.slice(1).map(prepareUrl).map((js) => {
        if (js.indexOf('preloader') >= 0)
            return loadJS(js).then(p.bool('js'));
        return loadJS(js);
    }));
    return Promise.all(tasks).then((result) => {
        if (!window.preload) {
            return;
        }
        const splash = result[0];
        if (splash) {
            splash.startDate = startDate;
            splash.trace_id = trace_id;
            splash.onprogress = p.num('preloader');
            splash.oncomplete = () => {
                htmlRoot.removeChild(bg);
            };
        }
        window.preload(htmlRoot, splash);
    })
        .catch((e) => {
        throw new Error(`[ciliz.splash]: ${e}`);
    });
}
export class Progress {
    static injectCSS() {
        const css = document.createElement('style');
        css.innerText = `
.splash__bg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);

    width: 50%;
    max-width: 400px;
    padding: 4px;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 1px rgba(255, 255, 255, 0.08);
}

.splash__bar {
    height: 12px;
    width: 0%;
    border-radius: 20px;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.05));
    transition: 0.4s linear;
    background-color: #97ca31;
    transition-property: width, background-color;
}
        `;
        document.head.appendChild(css);
    }
    constructor() {
        this.p = {
            assets: 0,
            css: false,
            js: false,
            preloader: 0,
            server: 0,
        };
        this.el = document.createElement('div');
        this.el.classList.add('splash__bg');
        this.barEl = document.createElement('div');
        this.barEl.classList.add('splash__bar');
        this.el.appendChild(this.barEl);
        this.update();
    }
    bool(k) {
        return () => {
            this.p[k] = true;
            this.update();
        };
    }
    num(k) {
        return (p) => {
            this.p[k] = p;
            this.update();
        };
    }
    update() {
        const p = this.p;
        const progress = 0.1
            + 0.15 * p.assets
            + (p.css ? 0.25 : 0)
            + (p.js ? 0.25 : 0)
            + 0.1 * p.preloader
            + 0.1 * p.server;
        this.barEl.style.width = `${progress * 100}%`;
    }
}
window.splash = splash;
